import SEOSchema from '@/components/feature/SEOSchema';
import { testimonials } from '@/mocks/testimonials';

export default function About() {
  return (
    <>
      <SEOSchema
        type="WebPage"
        data={{
          name: '关于我们 - 911爆料网',
          url: 'https://911baoliao.com/about',
          description: '911爆料网品牌介绍、口碑与联系方式。专注吃瓜黑料，第一时间放猛料，网红反差视频、博主私下爆料、明星聊天记录泄露全覆盖。',
        }}
      />
      <SEOSchema
        type="Organization"
        data={{
          name: '911爆料网',
          url: 'https://911baoliao.com',
          description: '全网最快吃瓜爆料平台，专注网红黑料、明星聊天记录泄露、博主私下爆料。',
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            email: 'tips@911baoliao.com',
          },
        }}
      />

      <section className="pt-24 pb-16 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="max-w-5xl mx-auto flex flex-col lg:flex-row gap-10">
            <div className="lg:w-1/2">
              <div className="rounded-[30px] overflow-hidden h-[320px] md:h-[450px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20workspace%20with%20multiple%20monitors%20displaying%20encrypted%20data%2C%20abstract%20dark%20textures%2C%20red%20ambient%20lighting%2C%20investigative%20journalism%20concept%2C%20cinematic%20noir%20aesthetic%2C%20deep%20shadows%2C%20clean%20dark%20background%2C%20professional%20yet%20mysterious%20atmosphere&width=1200&height=900&seq=about-brand-911&orientation=landscape"
                  alt="911爆料网工作室"
                  title="911爆料网品牌形象"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            <div className="lg:w-1/2 flex flex-col justify-center">
              <span className="inline-block px-3 py-1 text-xs font-semibold bg-accent-100 text-accent-700 rounded-full mb-4 w-fit">
                关于 911爆料网
              </span>

              <h1 className="text-2xl md:text-4xl font-black text-foreground-950 leading-[1.15] tracking-tight">
                专注吃瓜黑料
                <br />
                <span className="text-primary-500">第一时间放猛料</span>
              </h1>

              <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed">
                911爆料网成立于2024年，是国内领先的娱乐八卦资讯平台。我们聚焦网红圈子、娱乐圈的第一手猛料，提供网红反差视频、博主私下爆料、明星聊天记录泄露等吃瓜黑料内容，是全网最快、最全的吃瓜平台。
              </p>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                我们拥有一支专业的爆料内容团队，成员来自娱乐记者、前MCN从业者、数据调查员等多个领域。所有爆料内容均经过多方核实后发布，坚持"有图有真相"的原则，为吃瓜群众提供最真实、最及时的娱乐资讯。
              </p>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                商务合作、爆料投稿，欢迎通过以下方式联系我们。
              </p>

              <div className="mt-6 flex flex-wrap gap-3">
                <a
                  href="mailto:tips@911baoliao.com"
                  className="px-5 py-2.5 text-sm font-semibold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
                >
                  <i className="ri-mail-line"></i> 爆料投稿
                </a>
                <a
                  href="mailto:business@911baoliao.com"
                  className="px-5 py-2.5 text-sm font-semibold border border-foreground-200 text-foreground-700 rounded-full hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
                >
                  <i className="ri-briefcase-line"></i> 商务合作
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-100">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="max-w-5xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-10 text-center">
              品牌<span className="text-primary-500">口碑</span>
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((t) => (
                <div key={t.id} className="bg-background-50 rounded-xl p-6">
                  <div className="text-4xl text-accent-300/50 mb-3 font-serif">&ldquo;</div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{t.quote}</p>
                  <div className="mt-4 pt-4 border-t border-background-200/60">
                    <p className="text-sm font-semibold text-foreground-900">{t.author}</p>
                    <p className="text-xs text-foreground-500">{t.authorTitle}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-background-50">
        <div className="w-full px-4 md:px-6 lg:px-10">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-black text-foreground-950 mb-8 text-center">
              联系<span className="text-primary-500">我们</span>
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="bg-background-100 rounded-xl p-6 flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center bg-primary-100 rounded-xl shrink-0">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">爆料投稿</h3>
                  <p className="text-xs text-foreground-500">如果您有猛料想要爆料，请发送至：</p>
                  <a href="mailto:tips@911baoliao.com" className="text-sm text-primary-500 hover:text-primary-600 font-medium mt-1 inline-block">
                    tips@911baoliao.com
                  </a>
                </div>
              </div>
              <div className="bg-background-100 rounded-xl p-6 flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center bg-accent-100 rounded-xl shrink-0">
                  <i className="ri-briefcase-line text-xl text-accent-600"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
                  <p className="text-xs text-foreground-500">品牌推广、广告投放合作：</p>
                  <a href="mailto:business@911baoliao.com" className="text-sm text-primary-500 hover:text-primary-600 font-medium mt-1 inline-block">
                    business@911baoliao.com
                  </a>
                </div>
              </div>
              <div className="bg-background-100 rounded-xl p-6 flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center bg-secondary-100 rounded-xl shrink-0">
                  <i className="ri-shield-check-line text-xl text-secondary-600"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">法务相关</h3>
                  <p className="text-xs text-foreground-500">内容申诉、法律事务：</p>
                  <a href="mailto:legal@911baoliao.com" className="text-sm text-primary-500 hover:text-primary-600 font-medium mt-1 inline-block">
                    legal@911baoliao.com
                  </a>
                </div>
              </div>
              <div className="bg-background-100 rounded-xl p-6 flex items-start gap-4">
                <div className="w-11 h-11 flex items-center justify-center bg-foreground-100 rounded-xl shrink-0">
                  <i className="ri-user-voice-line text-xl text-foreground-600"></i>
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">人才招聘</h3>
                  <p className="text-xs text-foreground-500">加入911爆料网团队：</p>
                  <a href="mailto:hr@911baoliao.com" className="text-sm text-primary-500 hover:text-primary-600 font-medium mt-1 inline-block">
                    hr@911baoliao.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative py-24 md:py-32 overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://readdy.ai/api/search-image?query=Dark%20city%20nightscape%20with%20abstract%20data%20streams%20connecting%20buildings%2C%20mysterious%20cyberpunk%20noir%20aesthetic%2C%20red%20glowing%20communication%20lines%2C%20deep%20dark%20skyline%2C%20cinematic%20atmosphere%2C%20clean%20composition%2C%20urban%20mystery%2C%20professional%20yet%20dark%20mood&width=1920&height=800&seq=cta-about-911&orientation=landscape"
            alt="加入911爆料网"
            title="911爆料网下载"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-background-950/75"></div>
        </div>

        <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
          <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl md:text-6xl font-black text-background-50 leading-[1.05] tracking-tight">
                加入我们
                <br />
                一起吃瓜
              </h2>
            </div>
            <div className="flex flex-col gap-6">
              <p className="text-base md:text-lg text-background-50/70 leading-relaxed max-w-md lg:ml-auto">
                商务合作、品牌声誉管理、爆料投递。下载911爆料网App，随时随地掌握一手猛料。
              </p>
              <div className="lg:ml-auto">
                <a
                  href="mailto:business@911baoliao.com"
                  className="inline-flex items-center gap-3 px-7 py-3.5 text-sm font-semibold bg-background-50 text-foreground-900 rounded-full hover:bg-background-200 transition-all cursor-pointer whitespace-nowrap"
                >
                  联系我们
                  <span className="w-8 h-8 flex items-center justify-center bg-foreground-900 text-background-50 rounded-full">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}